import { formatMoneyMinorForAdvertiser } from '@/lib/formatters/money.formatter'

const countryPrices: Record<string, number> = {
  AU: 0.8,
  CZ: 0.1,
  DE: 0.15,
  ES: 0.05,
  FR: 0.15,
  GB: 0.08,
  IT: 0.1,
  NL: 0.08,
  NO: 1,
  PL: 0.35,
  RO: 0.07,
  SE: 1,
  SK: 0.1,
  UA: 0.1,
}

const defaultCurrencyPrices: Record<string, number> = {
  AUD: 0.8,
  EUR: 0.1,
  SEK: 1,
  NOK: 1,
  PLN: 0.35,
}

export const getRecommendedPrice = (
  country: string,
  currency: {
    symbol: string
    code: string
    is_before: number
  },
): string | undefined => {
  if (!country || !currency) {
    return undefined
  }

  const countryCode = country.toUpperCase()
  const currencyCode = currency.code?.toUpperCase()
  let price: number | undefined

  if (countryPrices[countryCode]) {
    price = countryPrices[countryCode]
  } else if (defaultCurrencyPrices[currencyCode]) {
    price = defaultCurrencyPrices[currencyCode]
  } else {
    return undefined
  }

  return formatMoneyMinorForAdvertiser(
    { amount: price, currency: currency.code },
    {
      currencySymbol: currency.symbol,
      isSymbolBefore: Boolean(currency.is_before),
      allowZero: true,
    },
  )
}
